var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alerts && _vm.alerts.length)?_c('div',{staticClass:"alerts"},[_c('h2',[_vm._v("Ga snel naar:")]),_vm._v(" "),_vm._l((_vm.alerts),function(alert){return _c('alert',{key:alert.sys.id,attrs:{"alert":alert}})})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }